<ion-header>
  <ion-toolbar>
    <ion-buttons
      slot="end"
      *ngIf="boosterDialogDetails?.closeCta"
    >
      <ion-button
        (click)="modalCtrl.dismiss()"
        fill="clear"
      >
        <ion-icon
          name="close"
          aria-label="close"
          slot="icon-only"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <mable-heading
    heading="h2"
    class="text-bold"
    >{{ boosterDialogDetails.title }}</mable-heading
  >
  <div
    [innerHTML]="boosterDialogDetails.body"
    class="ion-margin-horizontal"
  ></div>
</ion-content>

<ion-footer *ngIf="boosterDialogDetails?.closeCta || boosterDialogDetails?.confirmCta">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col *ngIf="boosterDialogDetails?.closeCta">
          <mable-button
            expand="block"
            category="outline"
            (onClick)="modalCtrl.dismiss()"
            class="ion-no-margin"
          >
            {{ boosterDialogDetails.closeCta }}</mable-button
          >
        </ion-col>
        <ion-col *ngIf="boosterDialogDetails?.confirmCta">
          <mable-button
            expand="block"
            mableOpenLinkButton
            [link]="{ ctaLink: boosterDialogDetails.confirmCtaLink }"
            (onClick)="modalCtrl.dismiss()"
            class="ion-no-margin"
            >{{ boosterDialogDetails.confirmCta }}</mable-button
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
